module.exports = __webpack_public_path__ + "static/img/6578_phase_function_Paper_Points.4cc3687.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6578_phase_function_Paper_Points.png
// module id = 3uqL
// module chunks = 0